<template>
  <img :src="image" alt="seq-tcga">
</template>

<script>

	import image from './seq-tcga.svg'

	export default {
		name: "seq-tcga-icon",

		data: function () {
			return {
				image,
			}
		}
	}
</script>

<style scoped>

</style>